import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/common/States";

export function Footer() {
  return (
    <footer className="mt-24 border-t border-black/[0.06] bg-[#f5f5f7] py-8 text-xs text-zinc-500">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 sm:px-6 md:flex-row md:justify-between">
        <p>© {new Date().getFullYear()} CreateFPV — FPV ilan ve keşif platformu. Ödeme ve teslimat site dışında, alıcı ile satıcı arasında gerçekleşir.</p>
        <div className="flex gap-4">
          <Link to="/yasal/kullanim-kosullari" data-testid="footer-terms">Kullanım koşulları</Link>
          <Link to="/yasal/aydinlatma-metni" data-testid="footer-kvkk">Aydınlatma metni</Link>
          <Link to="/yasal/gizlilik" data-testid="footer-privacy">Gizlilik</Link>
        </div>
      </div>
    </footer>
  );
}

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}

/** Guards: requires login (and completed profile for Google sign-ups). */
export function RequireAuth({ children, admin = false }) {
  const { user, loading, isAdmin } = useAuth();
  const loc = useLocation();
  if (loading) return <Loading />;
  if (!user) return <Navigate to={`/giris?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (user.profile_complete === false) return <Navigate to="/profil-tamamla" replace />;
  if (admin && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

export const Page = ({ children, className = "" }) => (
  <div className={`mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-16 ${className}`}>{children}</div>
);
